import { Record } from 'immutable'


const Ikyu = Record({
  accommodation_id: null,
  id:null,
  password:null
});
export default Ikyu;
